import { defineMessages } from 'react-intl';

const scope = 'app.builder.Knowledge.components.KnowledgeMapNode';

export default defineMessages({
  competencyDocumentItemDragObjectiveText: {
    id: `${scope}.competency.document.item.learning.objectives.dragtext`,
    defaultMessage: 'Drag Enabling Objective here or ',
  },
  competencyDocumentItemDragObjectiveLinkText: {
    id: `${scope}.competency.document.item.learning.objectives.dragLinktext`,
    defaultMessage: '+ add new Enabling Objective',
  },
});
